export const tokenAllowList: string[] = ['api', '/api', 'br', '/br', 'cw', '/cw', 'oc', '/oc'];
